
import { useEffect } from "react";

declare global {
  interface Window {
    Featurebase: {
      (...args: any[]): void;
      q?: any[];
    }
  }
}

const FeaturebaseWidget: React.FC = () => {
  useEffect(() => {
    // Add Featurebase SDK script
    const addScript = () => {
      if (!document.getElementById("featurebase-sdk")) {
        const script = document.createElement("script");
        script.id = "featurebase-sdk";
        script.src = "https://do.featurebase.app/js/sdk.js";
        script.async = true; // Make sure script loads asynchronously
        document.getElementsByTagName("script")[0].parentNode?.insertBefore(
          script,
          document.getElementsByTagName("script")[0]
        );
      }
    };

    // Create the Featurebase function if it doesn't exist
    if (!window.Featurebase) {
      window.Featurebase = function() {
        (window.Featurebase.q = window.Featurebase.q || []).push(arguments);
      };
    }

    // Add the script tag immediately
    addScript();

    // Initialize feedback widget with a slight delay to ensure SDK is loaded
    const initializeWidget = () => {
      window.Featurebase("initialize_feedback_widget", {
        organization: "saunadip",
        theme: "light", 
        placement: "right",
        email: "youruser@example.com",
        defaultBoard: "yourboardname",
        locale: "en",
        metadata: null
      });
    };

    // Wait for the script to load before initializing
    const timer = setTimeout(() => {
      initializeWidget();
    }, 1000);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      const script = document.getElementById("featurebase-sdk");
      if (script) {
        script.parentNode?.removeChild(script);
      }
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default FeaturebaseWidget;
